import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AutoLoginGuard, SelectivePreloadingStrategyService } from "./core";
import { PageNotFoundComponent } from "./public/page-not-found/page-not-found.component";

const routes: Routes = [
  {
    path: "**",
    canActivate: [AutoLoginGuard],
    component: PageNotFoundComponent,
    pathMatch: "full",
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: "enabled",
      scrollPositionRestoration: "enabled",
      onSameUrlNavigation: "reload",
      preloadingStrategy: SelectivePreloadingStrategyService,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
